import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    document.arrive('.srg-posts-list-container', {existing: true}, function() {
        let $block = $(this);
        $block.find('.news-filters select').change({block: $block}, function(e) {
            let query_vars = {
                post_type: 'post',
                post_status: 'publish',
                cat: 43,
                posts_per_page: 1000,
                orderby: 'date',
                orderway: 'DESC'
            };
            let year = parseInt($('#year').val());
            // let cat = parseInt($('#cat').val());
            if (year) {
                query_vars['date_query'] = {
                    0: {
                        'year': year,
                        compare: '='
                    },
                };
            }
            // if (cat) {
            // ....
            // }
            let loader = e.data.block.find('.srg-loader');
            $.ajax({
                url: srg.ajaxurl,
                type: 'post',
                data: {
                    action: 'get_news',
                    query_vars : JSON.stringify(query_vars),
                },
                success: function (results) {
                    loader.show();
                    // results = JSON.parse(results); // no need to parse it, results is already a json object
                    e.data.block.find('.srg-posts-list').replaceWith(results);
                    loader.hide();
                },
            })
        })
    });
});
